import { RootLayout, Sidebar } from '@insify/funnel-components';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { useHomeLink } from '../../../util/useHomeLink';
import { useCoBranding } from '../../hooks/useCoBranding';
import { useContactOptions } from '../../hooks/useContactOptions';
import { stepsContext } from '../../hooks/useSteps';
import { CoBrandingLogoSidebar } from '../CoBrandingLogo';
import { Wizard } from '../Wizard';

import * as styles from './FunnelLayout.module.css';

import type { Slug } from '../../hooks/useSteps/getSteps';

const FunnelSidebar = () => {
  const { t } = useTranslation(['funnel']);
  const contactOptionsTitle = t('funnel:sidebar_default_contact_label');
  const location = useLocation();
  const currentStepSlug = location.pathname.split('/')[2] as Slug;
  const { steps } = stepsContext.useHook();
  const { contactOptions, contactOptionsDescription } = useContactOptions();
  const { hasCoBranding } = useCoBranding();
  const homeLink = useHomeLink();

  const alreadyApplied = currentStepSlug === 'already-applied';

  return (
    <Sidebar<Slug>
      logo={hasCoBranding ? <CoBrandingLogoSidebar className={styles.partnerLogo} /> : undefined}
      logoHref={homeLink}
      currentStep={currentStepSlug}
      steps={steps.map((step) => step.slug)}
      stepsGroups={[
        {
          label: t('funnel:sidebar_step_describe_company'),
          firstStepOfTheNextGroup: alreadyApplied ? 'already-applied' : 'coverage',
        },
        {
          label: t('funnel:sidebar_step_select_your_coverages'),
          firstStepOfTheNextGroup: alreadyApplied ? 'already-applied' : 'past-claims-confirm',
        },
        {
          label: t('funnel:sidebar_step_complete_application'),
          firstStepOfTheNextGroup: alreadyApplied ? 'already-applied' : 'confirmation',
        },
      ]}
      contactOptionsTitle={contactOptionsTitle}
      contactOptions={contactOptions}
      contactOptionsDescription={contactOptionsDescription}
    />
  );
};

export function FunnelLayout(): JSX.Element {
  return <RootLayout sidebarElement={<FunnelSidebar />} mainElement={<Wizard />} />;
}
